import { combineSlices } from "@reduxjs/toolkit";
import { AuthApi } from "./api/AuthApi";
import { JobListApi } from "./api/JobListApi";
import { EventListApi } from "./api/EventListApi";
import { CommonApi } from "./api/CommonApi";
import { AuthSlice } from "./slices/AuthSlice";
import { DataApi } from "./api/DataApi";
import { NotificationSlice } from "./slices/NotificationSlice";

export const RootReducer = combineSlices(
  AuthSlice,
  NotificationSlice,
  { [AuthApi.reducerPath]: AuthApi.reducer },
  { [JobListApi.reducerPath]: JobListApi.reducer },
  { [EventListApi.reducerPath]: EventListApi.reducer },
  { [CommonApi.reducerPath]: CommonApi.reducer },
  { [DataApi.reducerPath]: DataApi.reducer }
);

export const apiMiddleware = [
  AuthApi.middleware,
  JobListApi.middleware,
  EventListApi.middleware,
  CommonApi.middleware,
  DataApi.middleware,
];
